<template>
    <div v-if="visible" class="modal-box-header">
        <div :tabindex="disabled ? 0 : -1">
            <Button
                v-if="onBack"
                class="modal-back"
                icon="Arrow"
                size="s"
                color="transparent"
                :ariaLabel="t({ key: 'shared.close' })"
                :onClick="onBack"
                :disabled="disabled" />

            <div class="modal-title">
                <Element v-if="title" element="h6" font="font-heading-6" class="title">
                    {{ title }}
                </Element>
                <Element v-if="subTitle" element="h3" font="font-body-m" class="subtitle">
                    {{ subTitle }}
                </Element>
            </div>
        </div>

        <ButtonIcon
            v-if="onClose"
            :ariaLabel="t({ key: 'shared.close' })"
            :onClick="onClose"
            icon="Cross"
            size="m"
            :disabled="disabled" />
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType, computed } from 'vue';
    import Button from '@ui/components/Button/Button.vue';
    import Element from '@ui/components/Element/Element.vue';
    import ButtonIcon from '@ui/components/Button/ButtonIcon.vue';

    export default defineComponent({
        name: 'Header',
        components: { Button, ButtonIcon, Element },
        methods: { t },
        props: {
            onBack: Function,
            onClose: Function,
            title: String,
            subTitle: { type: String as PropType<string | null> },
            disabled: { type: Boolean as PropType<boolean>, default: false },
        },
        setup(props) {
            const visible = computed<boolean>(() => {
                return Boolean(
                    props.onBack || props.onClose || props.title || props.subTitle
                );
            });

            return { visible };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Header.scss';
</style>
